import type { GridTreeOptions } from '../types'

export interface ResolvedTreeConfig {
  rowField: string
  parentField: string
  rootParentValue: unknown
  indent: number
  expandAll: boolean
  /** 是否显示树节点连接线（参考 vxe-table treeConfig.showLine） */
  showLine: boolean
  /** 是否显示根节点连接线 */
  showRootLine: boolean
}

export function resolveTreeConfig(options: GridTreeOptions): ResolvedTreeConfig {
  const tree = options.tree ?? {}
  return {
    rowField: tree.rowField ?? 'id',
    parentField: tree.parentField ?? 'parentId',
    rootParentValue: tree.rootParentValue ?? 0,
    indent: tree.indent ?? 16,
    expandAll: tree.expandAll ?? false,
    showLine: tree.showLine ?? true,
    showRootLine: tree.showRootLine ?? true,
  }
}

export function isRootTreeRow(
  row: Record<string, unknown>,
  config: ResolvedTreeConfig
) {
  const parentId = row[config.parentField]
  return parentId === config.rootParentValue
}
